<script>
import * as CCDb from '../../utilities/db'
export default {
  name: "NoView-ChangePin",
  async mounted() {
    const profile = await CCDb.getUserProfile()
    if (profile) {
      profile.set('pin', null)
      await profile.save()
    }
    this.$root.locked = true
    this.$router.replace('/')
  }
}
</script>
